import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, FsCatalog, TextInput } from '../../types'
import { CmsConverterService, defaultFSCatalog, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class SplitContainerAgendaTableConverter extends CmsConverterService<SplitContainerAgendaTableData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      headline: formData.st_headline ?? defaultTextInput,
      rows: formData.st_table_rows ?? defaultFSCatalog,
    }
  }
}

export const SPLIT_CONTAINER_AGENDA_TABLE_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, SplitContainerAgendaTableData>>('SplitContainerAgendaTableConverter')

export interface SplitContainerAgendaTableData extends ConvertedComponentData {
  headline: TextInput;
  rows: FsCatalog;
}
